const FILETYPE_EXTENSIONS = {
    Archive: ['zip', 'rar', '7z'],
    Audio: ['mp3', 'ogg', 'wav', 'aac'],
    Code: ['js'],
    Excel: ['xls', 'xlsx'],
    Image: ['jpg', 'jpeg', 'png', 'bmp', 'webp'],
    PDF: ['pdf'],
    PowerPoint: ['ppt', 'pptx'],
    Text: ['txt'],
    Video: ['mp4', 'flv', 'avi', 'wmv', 'mov'],
    Word: ['doc', 'docx']
};

export const getExtensionMapping = () => {
    const extensionMapping = Object.entries(FILETYPE_EXTENSIONS).reduce(
        (accM, [type, extensions]) => {
            const entry = extensions.reduce((acc, extension) => {
                acc[extension] = type;
                return acc;
            }, {});
            Object.assign(accM, entry);
            return accM;
        },
        {}
    );

    return extensionMapping;
};
